var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          class: { collapse: _vm.isCollapse },
          attrs: {
            "default-active": _vm.$route.Url,
            "unique-opened": "",
            router: false,
            collapse: _vm.isCollapse
          },
          on: {
            open: _vm.handleopen,
            close: _vm.handleclose,
            select: _vm.handleselect
          }
        },
        [
          _vm._l(_vm.menuList, function(item, index) {
            return [
              !item.hidden
                ? [
                    item.children && item.children.length > 0
                      ? _c(
                          "el-submenu",
                          {
                            key: index,
                            attrs: {
                              index: index + "",
                              "popper-class": "pop-submenu"
                            }
                          },
                          [
                            _vm.isCollapse
                              ? _c("template", { slot: "title" }, [
                                  _c("i", {
                                    staticClass: "el-submenu__icon iconfont",
                                    class: item.IconName
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "el-submenu__text" },
                                    [
                                      _vm._v(
                                        _vm._s(item.PermissionName || item.name)
                                      )
                                    ]
                                  )
                                ])
                              : [
                                  _c("i", {
                                    staticClass: "iconfont",
                                    class: item.IconName
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [
                                      _vm._v(
                                        _vm._s(item.PermissionName || item.name)
                                      )
                                    ]
                                  )
                                ],
                            _vm._v(" "),
                            _vm._l(item.children, function(child, index) {
                              return [
                                !child.hidden
                                  ? _c(
                                      "el-menu-item",
                                      {
                                        key: child.Url + "_" + index,
                                        attrs: { index: child.Url }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            child.PermissionName || child.name
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _c(
                          "el-menu-item",
                          {
                            key: index,
                            staticClass: "el-submenu__title",
                            attrs: { index: item.Url }
                          },
                          [
                            _vm.isCollapse
                              ? [
                                  _c("i", {
                                    staticClass: "iconfont el-submenu__icon",
                                    class: item.IconName
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "el-submenu__text" },
                                    [
                                      _vm._v(
                                        _vm._s(item.PermissionName || item.name)
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [
                                      _vm._v(
                                        _vm._s(item.PermissionName || item.name)
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                  ]
                : _vm._e()
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57c54b9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c54b9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBarMini.vue
// module id = null
// module chunks = 